import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { useTheme } from '../../contexts/ThemeContext';

export default function CustomLinearProgress() {
  const { theme } = useTheme();
  
  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress 
        sx={{
          '& .MuiLinearProgress-bar': {
            backgroundColor: theme.color.primary
          },
          backgroundColor: `${theme.color.primary}40` // 40 is for 25% opacity
        }}
      />
    </Box>
  );
}